import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementTemplates(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementTemplates?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementTemplates", responseData.data);
  },

  async postEngagementTemplate(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementTemplate`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementTemplate(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementTemplate`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementTemplate(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementTemplate`,
      "POST",
      null,
      postData
    );
  },
};
